import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import DynamicFontSize from "../DynamicFontSize";
import { ReactNode } from "react";
export interface ContentValuePropsType extends GeneralPropsType {
  valueDescription?: ReactNode;
  overrideValueFontsize?: number;
}
function ContentValue({
  valueDescription,
  overrideValueFontsize,
  children,
  className
}: ContentValuePropsType) {
  return <DynamicFontSize fontSize={overrideValueFontsize ?? 15} className={clsx({
    [styles.container]: true,
    [styles.value]: true,
    [className ?? ""]: true,
    "flex flex-col items-end": valueDescription
  })} data-sentry-element="DynamicFontSize" data-sentry-component="ContentValue" data-sentry-source-file="index.tsx">
      {children}
      {valueDescription && <div className={clsx("text-[calc(13em/18)]", styles.value_des)}>
          {valueDescription}
        </div>}
    </DynamicFontSize>;
}
export default ContentValue;